import {
  GEMINI_LIGHT_BORDER,
  GEMINI_LIGHT_CANVAS,
  GEMINI_LIGHT_ON_PRIMARY,
  GEMINI_LIGHT_PRIMARY,
  GEMINI_LIGHT_PRIMARY_DARK,
  GEMINI_LIGHT_SURFACE,
  GEMINI_LIGHT_SURFACE_ALT,
  GEMINI_LIGHT_TEXT_PRIMARY,
  GEMINI_LIGHT_TEXT_SECONDARY,
  GEMINI_AMBER,
  GEMINI_AMBER_DARK,
  GEMINI_BLUE,
  GEMINI_BLUE_DARK,
  GEMINI_GREEN,
  GEMINI_GREEN_DARK,
  GEMINI_RED,
  GEMINI_RED_DARK,
} from "../geminiPalette";

const colors = {
  background: {
    default: GEMINI_LIGHT_CANVAS,
    paper: GEMINI_LIGHT_SURFACE,
    card: GEMINI_LIGHT_SURFACE,
    sidenav: GEMINI_LIGHT_SURFACE_ALT,
    cardBorder: GEMINI_LIGHT_BORDER,
    cardBorderLeft: GEMINI_BLUE,
    section: GEMINI_LIGHT_SURFACE,
    sectionAlt: GEMINI_LIGHT_SURFACE_ALT,
  },

  text: {
    main: GEMINI_LIGHT_TEXT_PRIMARY,
    focus: "#000000",
    primary: GEMINI_LIGHT_TEXT_PRIMARY,
    secondary: GEMINI_LIGHT_TEXT_SECONDARY,
    disabled: "rgba(31, 31, 31, 0.38)",
  },

  divider: GEMINI_LIGHT_BORDER,

  transparent: {
    main: "rgba(0, 0, 0, 0)",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#3c4043",
    main: GEMINI_LIGHT_TEXT_PRIMARY,
    focus: "#000000",
  },

  primary: {
    main: GEMINI_LIGHT_PRIMARY,
    focus: GEMINI_LIGHT_PRIMARY_DARK,
    contrastText: GEMINI_LIGHT_ON_PRIMARY,
  },

  secondary: {
    main: GEMINI_LIGHT_TEXT_SECONDARY,
    focus: "#3c4043",
    contrastText: GEMINI_LIGHT_SURFACE,
  },

  info: {
    main: GEMINI_BLUE,
    focus: GEMINI_BLUE_DARK,
    contrastText: GEMINI_LIGHT_ON_PRIMARY,
  },

  success: {
    main: GEMINI_GREEN,
    focus: GEMINI_GREEN_DARK,
    contrastText: GEMINI_LIGHT_ON_PRIMARY,
  },

  warning: {
    main: GEMINI_AMBER,
    focus: GEMINI_AMBER_DARK,
    contrastText: "#000000",
  },

  error: {
    main: GEMINI_RED,
    focus: GEMINI_RED_DARK,
    contrastText: GEMINI_LIGHT_ON_PRIMARY,
  },

  light: {
    main: GEMINI_LIGHT_SURFACE_ALT,
    focus: GEMINI_LIGHT_BORDER,
  },

  dark: {
    main: GEMINI_LIGHT_TEXT_PRIMARY,
    focus: "#000000",
  },

  grey: {
    50: "#f8f9fa",
    100: "#f1f3f4",
    200: "#e8eef5",
    300: "#dadce0",
    400: "#bdc1c6",
    500: "#9aa0a6",
    600: "#80868b",
    700: "#5f6368",
    800: "#3c4043",
    900: "#202124",
  },

  priority: {
    critical: { main: GEMINI_RED, focus: GEMINI_RED_DARK },
    high: { main: GEMINI_AMBER, focus: GEMINI_AMBER_DARK },
    medium: { main: GEMINI_BLUE, focus: GEMINI_BLUE_DARK },
    low: { main: GEMINI_GREEN, focus: GEMINI_GREEN_DARK },
  },

  status: {
    new: { main: GEMINI_BLUE, focus: GEMINI_BLUE_DARK },
    assigned: { main: GEMINI_AMBER, focus: GEMINI_AMBER_DARK },
    inProgress: { main: "#9334e6", focus: "#7627bb" },
    onHold: { main: "#5f6368", focus: "#3c4043" },
    resolved: { main: GEMINI_GREEN, focus: GEMINI_GREEN_DARK },
    closed: { main: "#80868b", focus: "#5f6368" },
    cancelled: { main: GEMINI_RED, focus: GEMINI_RED_DARK },
  },

  gradients: {
    primary: { main: GEMINI_LIGHT_PRIMARY, state: GEMINI_LIGHT_PRIMARY_DARK },
    secondary: { main: "#5f6368", state: "#3c4043" },
    info: { main: GEMINI_BLUE, state: GEMINI_BLUE_DARK },
    success: { main: GEMINI_GREEN, state: GEMINI_GREEN_DARK },
    warning: { main: GEMINI_AMBER, state: GEMINI_AMBER_DARK },
    error: { main: GEMINI_RED, state: GEMINI_RED_DARK },
    light: { main: GEMINI_LIGHT_SURFACE_ALT, state: GEMINI_LIGHT_BORDER },
    /** Used by sidenav shell (expects dark rail + light menu text). */
    dark: { main: "#2d2d2d", state: "#131314" },
  },

  socialMediaColors: {
    facebook: { main: "#1877f2", dark: "#166fe5" },
    twitter: { main: "#1da1f2", dark: "#1a91da" },
    instagram: { main: "#e4405f", dark: "#d93a57" },
    linkedin: { main: "#0077b5", dark: "#005885" },
    pinterest: { main: "#bd081c", dark: "#8c0615" },
    youtube: { main: "#ff0000", dark: "#cc0000" },
    vimeo: { main: "#1ab7ea", dark: "#13a3d2" },
    slack: { main: "#4a154b", dark: "#350d36" },
    dribbble: { main: "#ea4c89", dark: "#e73177" },
    github: { main: "#24292e", dark: "#171a1d" },
    reddit: { main: "#ff4500", dark: "#e03d00" },
    tumblr: { main: "#35465c", dark: "#2a3749" },
  },

  badgeColors: {
    primary: { background: "#e8f0fe", text: GEMINI_LIGHT_PRIMARY_DARK },
    secondary: { background: GEMINI_LIGHT_SURFACE_ALT, text: GEMINI_LIGHT_TEXT_SECONDARY },
    info: { background: "#e8f0fe", text: GEMINI_BLUE_DARK },
    success: { background: "#e6f4ea", text: GEMINI_GREEN_DARK },
    warning: { background: "#fef7e0", text: GEMINI_AMBER_DARK },
    error: { background: "#fce8e6", text: GEMINI_RED_DARK },
    light: { background: GEMINI_LIGHT_SURFACE, text: GEMINI_LIGHT_TEXT_SECONDARY },
    dark: { background: GEMINI_LIGHT_SURFACE_ALT, text: GEMINI_LIGHT_TEXT_PRIMARY },
  },

  coloredShadows: {
    primary: GEMINI_LIGHT_PRIMARY,
    secondary: GEMINI_LIGHT_TEXT_SECONDARY,
    info: GEMINI_BLUE,
    success: GEMINI_GREEN,
    warning: GEMINI_AMBER,
    error: GEMINI_RED,
    light: "#bdc1c6",
    dark: GEMINI_LIGHT_TEXT_PRIMARY,
  },

  inputBorderColor: GEMINI_LIGHT_BORDER,

  tabs: {
    indicator: { boxShadow: GEMINI_LIGHT_BORDER },
  },
};

export default colors;
